import type { V2AiJob } from '../domain/aiJob';
import { latestReviewForItem } from '../domain/aiJob';
import { aiJobsStore } from './aiJobsStore';
import { aiStore } from './aiStore';
import { rowFactsFrom, type RowFactsInput } from './closeout';
import { evidenceStore } from './evidenceStore';

// The advanced review summary of every row that has one (itemId → summary), for the closeout and the
// report assembly, which read state snapshots rather than the stores' live providers.
export function advancedSummariesOf(jobs: readonly V2AiJob[]): Map<string, string> {
  const out = new Map<string, string>();
  for (const itemId of new Set(jobs.map((j) => j.itemId))) {
    const review = latestReviewForItem(jobs, itemId);
    if (review?.result) out.set(itemId, review.result.summary);
  }
  return out;
}

// The row facts as the stores hold them now — for the non-React callers of buildCloseout.
export function liveRowFacts(): RowFactsInput {
  return rowFactsFrom(aiStore.get(), evidenceStore.get(), advancedSummariesOf(aiJobsStore.get().jobs));
}
